import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function CircleCross(props: IconProps) {
  return (
    <IconSvg {...props}>
      <path d="M13.044 12.336l4.949 4.95 4.95-4.95a.5.5 0 01.707.708l-4.95 4.949 4.95 4.95a.5.5 0 01-.707.707l-4.95-4.95-4.95 4.95a.5.5 0 01-.707-.707l4.95-4.95-4.95-4.95a.5.5 0 01.708-.707zM34 18c0 8.837-7.163 16-16 16S2 26.837 2 18 9.163 2 18 2a16 16 0 0116 16zm-1 0c0-8.284-6.716-15-15-15C9.716 3 3 9.716 3 18c0 8.284 6.716 15 15 15 8.28-.01 14.99-6.72 15-15z"></path>
    </IconSvg>
  );
}
